import base from "./base";
import { addErrorNotification } from "../utils/notifications";

export const getPositions = params =>
	base
		.get("/position?sortBy=published_at", {
			params
		})
		.then(res => res.data)
		.catch(() =>
			addErrorNotification(
				"Unable to load <strong>Positions list</strong>"
			)
		);



// WEBPACK FOOTER //
// ./src/services/positions.js